<template>
  <div style="margin-top:30px">
    <el-form ref="form" label-width="100px" :model="form" disabled>
      <el-form-item label="选择机构" prop="branchCode" style="margin-right:15px">
        <el-select v-model="form.branchCode" placeholder="请选择">
          <el-option v-for="item in branchList" :key="item.code" :label="item.groupName" :value="item.code" />
        </el-select>
      </el-form-item>
      <el-form-item label="银行类型" prop="type" style="margin-right:15px">
        <el-select v-model="form.type" placeholder="请选择" clearable>
          <el-option v-for="item in BankTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="开户企业名称" prop="companyName" style="margin-right:15px">
        <el-input v-model="form.companyName" placeholder="请输入开户企业名称" />
      </el-form-item>
      <el-form-item label="预留手机号" prop="phone" style="margin-right:15px">
        <el-input v-model="form.phone" placeholder="请输入预留手机号" />
      </el-form-item>
      <el-form-item label="银行卡号" prop="bankNum" style="margin-right:15px">
        <el-input v-model="form.bankNum" placeholder="请输入银行卡号" />
      </el-form-item>
      <el-form-item label="开户银行" prop="bankName" style="margin-right:15px">
        <el-input v-model="form.bankName" />
      </el-form-item>
      <el-form-item label="开户行省份" prop="bankProvince" style="margin-right:15px">
        <el-input v-model="form.bankProvince" />
      </el-form-item>
      <el-form-item label="开户行城市" prop="bankCity" style="margin-right:15px">
        <el-input v-model="form.bankCity" />
      </el-form-item>
      <el-form-item label="联行号" prop="associateBankNumber" style="margin-right:15px">
        <el-input v-model="form.associateBankNumber" />
      </el-form-item>
      <el-form-item label="开户网点" prop="bankBranch" style="margin-right:15px">
        <el-input v-model="form.bankBranch" />
      </el-form-item>
      <el-form-item label="是否默认" prop="isDefault" style="margin-right:15px">
        <el-switch v-model="form.isDefault" :active-value="1" :inactive-value="0" />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'PlatformHouseholdDetail',
  data() {
    return {
      emptyForm: {},
      form: {
        code: '',
        isDefault: '',
        bankBranch: '',
        associateBankNumber: '',
        bankCity: '',
        bankProvince: '',
        bankName: '',
        bankNum: '',
        phone: '',
        companyName: '',
        branchCode: '',
        modifiedByName: ''
      },
      BankTypeOptions: [
        { label: '转账支付', value: 1 },
        { label: '银行支付', value: 0 }
      ],
      // 机构列表
      branchList: this.$store.state.components.branchList,
    }
  },
  created() {
    //保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form))
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      //查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      request({
        url: `/ntocc-basic-api/platformHousehold/${code}`,
        method: 'get'
      }).then((response) => {
        this.form = response.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin-top: 50px;
}
</style>
